import { useState, useContext, useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AccessContext } from './context.js';

const AccessRoute = () => {
    const access = useContext(AccessContext);
    const location = useLocation();
    const [hasAccess, setHasAccess] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (Object.keys(access || {}).length === 0) {
            setHasAccess(true);
            return;
        }
        if (access.cms == false) {
            navigate('/login');
            return;
        }
        var _access = false;
        switch (location.pathname) {
            case '/sponsor':
            case '/sponsor-list':
                if (access.sponsors)
                    _access = true;
                break;
            case '/merch':
            case '/merch-list':
                if (access.merch)
                    _access = true;
                break;
            case '/event':
            case '/event-list':
            case '/past-events':
                if (access.events)
                    _access = true;
                break;
            case '/user':
            case '/user-list':
                if ((access.users && access.role == 'Admin') || access.isSuper)
                    _access = true;
                break;
            case '/professions':
            case '/template-builder':
            case '/template-list':
            case '/manage-profiles':
                if (access.isSuper)
                    _access = true;
                break;
            case '/image-list':
            case '/video-list':
            case '/link-list':
                if (access.role != 'Host/Guest')
                    _access = true;
                break;
        }
        if (location.pathname.startsWith('/protected/')) {
            if (access.isSuper)
                _access = true;
        }
        setHasAccess(_access);
    }, [access]);
    if (!access?.role) {
        return (
            <div className="loading mt-100" style={{ color: '#AAA5BF' }}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }
    return hasAccess ? <Outlet /> : <Navigate to="/" />;
}

export default AccessRoute;